import { useMutation, useQueryClient } from '@tanstack/react-query';

import { deleteOrganizationFile } from '@/api/v4/organization-files.api';
import { QueryKey } from '@/config/query-client';

import { companyIdState } from '../../companies/overview/company.state';
import { useCompanyFetchMode } from '../../companies/overview/company-fetch-context';
import { useAtomValue } from 'jotai';

export const useDeleteCompanyFile = () => {
  const queryClient = useQueryClient();
  const companyId = useAtomValue(companyIdState);
  const fetchMode = useCompanyFetchMode();

  const mutation = useMutation({
    mutationFn: deleteOrganizationFile,
    onSuccess: async () => {
      await Promise.all([
        queryClient.invalidateQueries({ queryKey: [QueryKey.CompanyFiles] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.CompanyActionsInfo],
        }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.Company, fetchMode, companyId],
        }),
        queryClient.invalidateQueries({ queryKey: [QueryKey.LastActivities] }),
        queryClient.invalidateQueries({
          queryKey: [QueryKey.LastActivitiesCount],
        }),
      ]);
    },
  });

  const deleteCompanyFile = (fileId: string) => {
    if (!companyId) return;

    return mutation.mutateAsync({ organizationId: companyId, fileId });
  };

  return {
    deleteCompanyFile,
    isError: mutation.isError,
  };
};
